import { z } from 'zod';
export const POLICY_FIT_STATUS_VALUES = {
    NEUTRAL: 'neutral',
    RESTRICTED: 'restricted',
    PROHIBITED: 'prohibited',
    UNVERIFIED: 'unverified'
};
const POLICY_FIT_STATUSES = Object.values(POLICY_FIT_STATUS_VALUES);
export const PolicyFitStatusSchema = z.enum(POLICY_FIT_STATUSES);
export const PolicyFitSchema = z.object({
    status: PolicyFitStatusSchema.nullable(),
    displayName: z.string().nullable(),
    version: z.number().nullable(),
    description: z.string().nullable(),
    policyFitSnippet: z.string().nullable()
});

//# sourceMappingURL=policy-fit.schema.js.map